import { render, staticRenderFns } from "./electricity.vue?vue&type=template&id=f5522d98&"
import script from "./js/electricity.js?vue&type=script&lang=js&"
export * from "./js/electricity.js?vue&type=script&lang=js&"
import style0 from "./electricity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports